import '../../styles/banner/banner-admarking.less';
import '../../styles/banner/banner-caption.less';
import '../../styles/banner/banner-base.less';
import '../../styles/banner/banner-logo.less';
import '../../styles/banner/banner-media.less';
import '../../styles/banner/job/banner-job-header.less';
